package de.xtl.retroguide

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalFontFamilyResolver
import de.xtl.retroguide.join.JoinSessionRoot
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.withTimeoutOrNull

@Composable
fun App(
    sessionAccessStorage: SessionAccessStorage = defaultSessionAccessStorage(),
    initialSessionCode: String? = null,
    onDownloadMarkdown: (String, String) -> Unit = { _, _ -> },
    onShareMarkdown: (String, String) -> Unit = { _, _ -> },
) {
    val fontFamilyResolver = LocalFontFamilyResolver.current
    var fontsReady by remember { mutableStateOf(false) }
    LaunchedEffect(fontFamilyResolver) {
        try {
            withTimeoutOrNull(FONT_PRELOAD_TIMEOUT_MILLIS) { fontFamilyResolver.preloadEmojiFallback() }
        } catch (e: CancellationException) {
            throw e
        } catch (_: Exception) {
            // Without the fallback font emoji may render as boxes, but the app stays usable.
        }
        fontsReady = true
    }
    AppTheme {
        if (fontsReady) {
            JoinSessionRoot(
                sessionAccessStorage = sessionAccessStorage,
                initialSessionCode = initialSessionCode,
                onDownloadMarkdown = onDownloadMarkdown,
                onShareMarkdown = onShareMarkdown,
            )
        } else {
            Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                CircularProgressIndicator()
            }
        }
    }
}

private const val FONT_PRELOAD_TIMEOUT_MILLIS = 3_000L

@Composable
fun AppTheme(content: @Composable () -> Unit) {
    MaterialTheme(content = content)
}
